var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"slotRef",staticStyle:{"cursor":"pointer"},on:{"click":_vm.copyWord}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }